import Footer from "../../../navigation/footerContainer";
import PaymentContainer from "./paymentContainer";


export default function ManagePaymentsPage() {
    return (
        <>
            <PaymentContainer />
            <Footer />
        
        </>
    )

}